// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"op-z","breadcrumbForward":"pp-z","breadcrumbBack":"qp-z","selected":"rp-z"};